import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Big Mac index and Jest fetch testing",
  "description": "",
  "published": "2019-08-22T00:00:00.000Z",
  "redirect_from": ["/blog/the-big-mac-index-and-jest-fetch-testing/swizec/9187"],
  "categories": "Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1566489636202.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Big Mac index is a purchasing power parity index published by The Economist. Jest fetch testing is a tech task so frustrating that it almost made me quit the industry.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1164413095319494656"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "121.0762331838565%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'484\\'%20viewBox=\\'0%200%20400%20484\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2023c-4%204-4%204-4%2011l1%207%201%202c0%203%2012%207%2017%205s7-5%204-5c-4%200-5-3-2-5l3-1%203-2c6-5-4-16-14-16-5%200-5%200-9%204m-1%20123c-4%203-4%203-4%20121l1%20116%202%202%202%203h268l3-3c4-2%206-2%206%200s3%203%205%203v-3c-4-3%201-6%209-4l17%201%2013%201%204-3%2019-15v-11l1-103V148l-2-2-3-2H199c-153%200-170%200-171%202m216%2019c-9%202-16%2012-22%2030v10c2%205%204%205%204-1l1-8%202-5c1-3%204-2%207%201s3%203-2%2012c-3%206-3%208-3%2010%202%203%204%202%204-1s0-4%203-4l7%202c2%201%202%201%200%203-1%202-1%202%201%202l3%202c1%201%207%202%207%200s5-3%207-2c1%201%202%202%203%201h2c1%201%2010%205%2011%204l-1-1c-2%200-1-2%201-2l1%201c-2%202%203%201%204-1%203-3%207-13%207-16%200-4%201-6%203-6l4-1c2-2%202-2%201-3h-7c-2%201-5-2-5-4%201-1%200-2-3-4l-4-4c0-2-1-3-3-4s-2-2-2-5c1-2%201-3-4-5-6-2-19-3-27-1m10%2028c-4%203-4%206%200%2012l3%204c0%202%204%204%209%205%207%201%208%201%206-2l-2-6c0-5-6-14-9-14h-2c-1-1-3%200-5%201m-64%2055c-7%204-10%209-11%2016-1%2015%2012%2025%2026%2022h5l3%202v1l-1%203c0%202%200%202%203%202%202%200%203%200%202%201l4%201a542%20542%200%200123-1c-1-1-2%201-2%203%200%204%200%204%204%204%203%200%203%200%203-2%200-4%201-6%202-5l5%201c3%200%204-1%204-4%200-6-7-15-10-13-3%201-2-3%200-5%203-3%202-3-1-1-4%202-5%200-1-3l2-3v-3c0-3-2-6-4-6l-2-1-9-3c-2%200-3%201-3%203s0%202%201%201c3-2%205%200%203%203h-3c-2-1-3%202-3%2013l1%209-4%201-10%201h-7l3-4c6-5%207-8%207-15%200-16-17-26-30-18m2%202c-17%208-12%2032%206%2034%2019%201%2027-23%2011-34-4-2-13-3-17%200m-67%203l-6%202-10%201c-13%200-17%202-6%202a222%20222%200%200032%200c-2%201-1%202%202%201l1-1%204-1h4c0-1%201-2%203-2%203-2%203-2-4-2a203%20203%200%2001-20%200m69%2013v9l3-2a184%20184%200%200111-7l-14-9v9m70-3l-1%201-1%203c0%202-3%203-5%201h-1l-3%201h-2l2%202%205%201c2%200%201%202-1%202s-2%200-1%201c3%201%208%205%208%207l1%201v-3l1-4%201%203%202%204%202%201c2%203%201-2-1-6l-3-10-2-6-1%201m36%2022l-9%202-11%202h-8l-5%201c-2%200-2%200-1%201l1%203v7c1%203-5%206-9%206-3-1-4-1-6%202-5%205-7%206-14%203l-7-2c-2%200-2%200%200%201%203%201%202%203-2%203-3%200-4-1-2-3l-13%201-52%2012%2013%207v-1c-1-2%200-2%201-2%202%200%203-1%203-2%200-4%202-5%204-3%203%201%2028%206%2034%206l6%202%203%201%205-1%206-2%206-1%205-1%205-1c6%200%208-1%2011-2h3l1-1c0-1%207-1%208%201l1%205c0%203%201%204%202%205l1%202v6c-2%200-2%200%200%203l3%204c0%202%207%204%2012%204%208%200%208-1%201-3-8-3-13-6-15-10s0-5%207-1a62%2062%200%200028%2010l2-1-2-1-1-2c1-2%200-2-1-2l-1%202-1%201c-3%200-19-10-18-11l-1-1-1-3-2-3-2-2%202%201c3%200%2015%208%2019%2012%203%203%206%204%203%201-2-3-1-3%204%200s9%204%207%201c-2-6%200-8%206-4%202%203%202%203%200%203l-2-1h-1c-2%204%200%206%206%204h3v-25h6c7%200%2025-2%2028-4%201-1%201-1-1-2l-7-4c-7-5-8-6-16-7-7-1-11-1-13%202-1%201-2%201-6-4-4-4-5-5-10-6l-7-2-3-3c-1-3-5-4-6-3m-159%204l-12%202c-3%200-4%201-2%203%201%201%206%201%2010-1h3l11-2c4-1%205-2%203-4-2-1-3-1-13%202m56%207c-5%200-3%202%204%203l7%202%202%201%202%202%202%202c2%200%203-5%202-7l-1-2h-1c-2-1-13-2-17-1M84%20309l-2%201-2%203-1%203%202%202%204%203a206%20206%200%200013%2011c3%204%2011%206%2013%204l-3-1-6-4-6-5c-2%200-5-3-7-5l-6-5%201-1c3%200%204-1%201-3-2-3%201-3%204%200l8%206c5%203%205%204%205%207s0%204%203%205c4%201%205%201%205-1%201-2%201-2%202-1l2%204%201%203%2015-5c1%200-1-3-5-5-4-3-5-4-5-2l-1%201-2-3c0-2-1-3-11-11H91c-4-2-7-2-7-1m49%20116l-3%205-1%204c-2%201%200%204%203%204%203%201%208-2%207-4l1-1%201-3c0-2%200-3-1-2h-2c-2%200-2%200-1-2%202-1%202-1%200-2s-2-1-4%201m124%200c-3%203-3%205-2%207%200%202%201%202%202%201v-2l1-2h2v2h2l-2%203c-3%202-2%204%201%204l5-1-2-1-3-1h4l3-1v-3l-2%201-1%201-1-1-2-3c-1-1-2-2-1-3l3%202c1%202%205%203%205%201s-4-5-7-6c-2%200-3%200-5%202m-110%202c-2%203-3%206-1%209%204%204%2010%203%2013-2%201-2%200-7-1-6l-7-3c0-2-2-1-4%202m128-1c-4%204-2%2011%203%2012%208%201%2012-6%207-11-3-4-8-4-10-1m-53%200v3c0%202%200%202-2%202-2-1-2-1-2%202%201%206%208%208%2013%203%203-4%203-7%200-8-2-1-3%200-2%202%200%202-3%200-3-2-1-2-3-4-4-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/336571388797b2c816bdaf75dd735590/ca0a1/techletter.app-screenshot-1566489636202.webp 223w", "/static/336571388797b2c816bdaf75dd735590/75680/techletter.app-screenshot-1566489636202.webp 445w", "/static/336571388797b2c816bdaf75dd735590/0ba47/techletter.app-screenshot-1566489636202.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/336571388797b2c816bdaf75dd735590/e92b6/techletter.app-screenshot-1566489636202.png 223w", "/static/336571388797b2c816bdaf75dd735590/e66bf/techletter.app-screenshot-1566489636202.png 445w", "/static/336571388797b2c816bdaf75dd735590/6af66/techletter.app-screenshot-1566489636202.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/336571388797b2c816bdaf75dd735590/6af66/techletter.app-screenshot-1566489636202.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Screenshots don't have gifs, here:`}</p>
    <p><img parentName="p" {...{
        "src": "/3f0ba795b27465987ad0dd092c43684d/media-EtB1yylKGGAUg-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`I'm writing this so you don't have to read 8234721 different blog posts, stack overflow answers, and GitHub threads with conflicting info on how to get Jest and fetch to play together.`}</p>
    <p>{`Library where I got it working 👉 `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/bigmac-index-price-calculator"
      }}>{`bigmac-index-price-calculator`}</a>{`.`}</p>
    <p>{`Context is a project built from scratch without a CLI generator. Maybe that was part of my pain.`}</p>
    <h2 {...{
      "id": "how-to-test-fetch-requests-with-jest"
    }}>{`How to test fetch requests with Jest`}</h2>
    <p>{`A couple of ground rules:`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Our test suite must work offline.`}</strong>{` You shouldn't be blocked from coding just because you're on an airplane even if coding on an airplane is a terrible idea and you should really get some sleep instead.`}</li>
      <li parentName="ol"><strong parentName="li">{`Our test suite must be reliable.`}</strong>{` You don't want to get different results running at different times. No expiring API keys, no changing responses, no network failures.`}</li>
    </ol>
    <p>{`We're using Jest because it's winning the JavaScript and TypeScript testing market. fetch() because it's the standard way to make API requests.`}</p>
    <p>{`Our ground rules mean we have to mock requests – make them return a static object that we set up. Recording and replaying requests would be cool, but as far as I can tell `}<a parentName="p" {...{
        "href": "https://github.com/vcr/vcr"
      }}>{`Ruby VCR`}</a>{` hasn't made it to the JavaScript world yet.`}</p>
    <p>{`There's at least 2 fetch mocking libraries I could find: `}<a parentName="p" {...{
        "href": "https://github.com/wheresrhys/fetch-mock"
      }}>{`fetch-mock`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/jefflau/jest-fetch-mock"
      }}>{`jest-fetch-mock`}</a>{`. Both annoying as shit to set up. `}<inlineCode parentName="p">{`fetch-mock`}</inlineCode>{` was the one I got working in the end.`}</p>
    <p>{`Jest tests run in node. Node doesn't have fetch. You have to use a library for that too. There's a fetch polyfills and ponyfills and Idontknowwhatelsefills out there. I found at least 3.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/matthew-andrews/isomorphic-fetch"
      }}>{`isomorphic-fetch`}</a>{` is the library I got working in the end.`}</p>
    <p>{`Let us begin.`}</p>
    <h3 {...{
      "id": "install-dependencies"
    }}>{`Install dependencies`}</h3>
    <p>{`Assuming you've got an empty project initialized with `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` or `}<inlineCode parentName="p">{`yarn init`}</inlineCode>{`, you start by installing everything you'll need`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=bash&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=yarn%20add%20--dev%20jest%20%40types%2Fjest%20ts-jest%20fetch-mock%20"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "510px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "36.77130044843049%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'147\\'%20viewBox=\\'0%200%20400%20147\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2039c-2%202-2%2068%200%2070s346%202%20348%200%202-68%200-70-346-2-348%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d9dcfb3ef5bb0078836540fe0a453b25/ca0a1/techletter.app-screenshot-1566489636897.webp 223w", "/static/d9dcfb3ef5bb0078836540fe0a453b25/75680/techletter.app-screenshot-1566489636897.webp 445w", "/static/d9dcfb3ef5bb0078836540fe0a453b25/b7235/techletter.app-screenshot-1566489636897.webp 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d9dcfb3ef5bb0078836540fe0a453b25/e92b6/techletter.app-screenshot-1566489636897.png 223w", "/static/d9dcfb3ef5bb0078836540fe0a453b25/e66bf/techletter.app-screenshot-1566489636897.png 445w", "/static/d9dcfb3ef5bb0078836540fe0a453b25/0abdd/techletter.app-screenshot-1566489636897.png 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d9dcfb3ef5bb0078836540fe0a453b25/0abdd/techletter.app-screenshot-1566489636897.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Dev dependencies are those only used in development. We need Jest itself, its type definitions, its TypeScript sister, and fetch-mock.`}</p>
    <p>{`Using `}<inlineCode parentName="p">{`ts-jest`}</inlineCode>{` gives you TypeScript testing superpowers so you don't have to compile your code first and test second. Test your TypeScript directly. It's nice.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=bash&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=yarn%20add%20isomorphic-fetch"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "302px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "61.88340807174888%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'248\\'%20viewBox=\\'0%200%20400%20248\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M45%2066l-2%203v56c0%2054%200%2057%202%2059s38%203%20156%203c117%200%20153-1%20155-3s2-5%202-59V68l-2-2-3-2H47l-2%202m47%2021c-4%205-1%2013%205%2013%203%200%208-5%208-8%200-7-9-10-13-5m29-2c-5%202-6%207-3%2011%205%207%2015%200%2012-7%200-2-5-5-6-5l-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9088093c97be63b1e29369b8d3805a56/ca0a1/techletter.app-screenshot-1566489636861.webp 223w", "/static/9088093c97be63b1e29369b8d3805a56/7cc02/techletter.app-screenshot-1566489636861.webp 302w"],
                "sizes": "(max-width: 302px) 100vw, 302px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9088093c97be63b1e29369b8d3805a56/e92b6/techletter.app-screenshot-1566489636861.png 223w", "/static/9088093c97be63b1e29369b8d3805a56/5f1d2/techletter.app-screenshot-1566489636861.png 302w"],
                "sizes": "(max-width: 302px) 100vw, 302px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9088093c97be63b1e29369b8d3805a56/5f1d2/techletter.app-screenshot-1566489636861.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We need `}<inlineCode parentName="p">{`isomorphic-fetch`}</inlineCode>{` both in development and when running live. That way your library doesn't break if used server-side in Gatsby or something.`}</p>
    <h3 {...{
      "id": "configure-jest"
    }}>{`Configure Jest`}</h3>
    <p>{`Configure Jest in a `}<inlineCode parentName="p">{`jest.config.js`}</inlineCode>{` file. There's a bunch of info out there on where exactly this configuration should live. This is the one that finally worked for me.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20jest.config.js%0A%0Amodule.exports%20%3D%20%7B%0A%20%20%20%20%22roots%22%3A%20%5B%0A%20%20%20%20%20%20%20%20%22.%2Fsrc%22%0A%20%20%20%20%5D%2C%0A%20%20%20%20%22transform%22%3A%20%7B%0A%20%20%20%20%20%20%20%20%22%5E.%2B%5C%5C.tsx%3F%24%22%3A%20%22ts-jest%22%0A%20%20%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "358px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "97.30941704035874%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'390\\'%20viewBox=\\'0%200%20400%20390\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M38%2056c-2%202-2%203-2%20140s0%20138%202%20140c3%203%20322%203%20325%200s3-277%200-280-322-3-325%200m40%2017c-4%204-1%2011%204%2011%203%200%207-4%207-6%200-6-8-9-11-5m22%200l-2%205c0%202%204%206%206%206%203%200%207-4%207-6l-2-5-4-2-5%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/074c816315bb313836c4019235d3d8de/ca0a1/techletter.app-screenshot-1566489636670.webp 223w", "/static/074c816315bb313836c4019235d3d8de/44bcf/techletter.app-screenshot-1566489636670.webp 358w"],
                "sizes": "(max-width: 358px) 100vw, 358px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/074c816315bb313836c4019235d3d8de/e92b6/techletter.app-screenshot-1566489636670.png 223w", "/static/074c816315bb313836c4019235d3d8de/39185/techletter.app-screenshot-1566489636670.png 358w"],
                "sizes": "(max-width: 358px) 100vw, 358px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/074c816315bb313836c4019235d3d8de/39185/techletter.app-screenshot-1566489636670.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We're saying code lives in a `}<inlineCode parentName="p">{`/src`}</inlineCode>{` directory and that typescript files should run with `}<inlineCode parentName="p">{`ts-jest`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "mock-fetch-requests"
    }}>{`Mock fetch requests`}</h3>
    <p>{`Jest has built-in support for mocking entire libraries. That was a nice discovery after trying many approaches from many articles and tutorials.`}</p>
    <p>{`You put files in a `}<inlineCode parentName="p">{`__mocks__`}</inlineCode>{` directory and they overwrite the library you're calling.`}</p>
    <p><img parentName="p" {...{
        "src": "/9a021a6cd72cfaab539f3b1fef648ed9/media-12NUbkX6p4xOO4-giphy.gif",
        "alt": "magic giphy"
      }}></img></p>
    <p>{`To use `}<inlineCode parentName="p">{`fetch-mock`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`isomorphic-fetch`}</inlineCode>{` in your tests, create a file like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2F__mocks__%2Fisomorphic-fetch%0A%0Aconst%20fetchMock%20%3D%20require('fetch-mock')%0A%0Aconst%20fetch%20%3D%20fetchMock.sandbox()%3B%0Amodule.exports%20%3D%20fetch%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "414px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'268\\'%20viewBox=\\'0%200%20400%20268\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2048l-1%2087%201%2085%202%202%20166%201%20166-1%203-2v-85l-1-87c-2-2-334-2-336%200m35%2015c-4%204-2%209%204%209%203%200%205-2%205-5%200-5-6-8-9-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/12905e4a2becda48bb1edcb2a4404842/ca0a1/techletter.app-screenshot-1566489636850.webp 223w", "/static/12905e4a2becda48bb1edcb2a4404842/3ca80/techletter.app-screenshot-1566489636850.webp 414w"],
                "sizes": "(max-width: 414px) 100vw, 414px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/12905e4a2becda48bb1edcb2a4404842/e92b6/techletter.app-screenshot-1566489636850.png 223w", "/static/12905e4a2becda48bb1edcb2a4404842/b910a/techletter.app-screenshot-1566489636850.png 414w"],
                "sizes": "(max-width: 414px) 100vw, 414px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/12905e4a2becda48bb1edcb2a4404842/b910a/techletter.app-screenshot-1566489636850.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This means that every time you import `}<inlineCode parentName="p">{`isomorphic-fetch`}</inlineCode>{` in a test file, it will instead import a sandboxed `}<inlineCode parentName="p">{`fetch-mock`}</inlineCode>{` instance. You can add any other setup you want here. Anything you need for your mocks to work correctly.`}</p>
    <p><strong parentName="p">{`BIG WARNING`}</strong>{` 👉 you have to use the `}<inlineCode parentName="p">{`require()`}</inlineCode>{` syntax. No ES6 imports because this is Node not JavaScript. That tripped me up for hours and rumors say you `}<em parentName="p">{`can`}</em>{` get `}<inlineCode parentName="p">{`import from`}</inlineCode>{` to work, but I eventually gave up.`}</p>
    <h3 {...{
      "id": "write-a-jest-fetch-test"
    }}>{`Write a Jest fetch test`}</h3>
    <p>{`We're ready to write a test. Everything `}<em parentName="p">{`should`}</em>{` work.`}</p>
    <p>{`The file I'm testing is called `}<inlineCode parentName="p">{`index.ts`}</inlineCode>{` so my test file is called `}<inlineCode parentName="p">{`index.test.ts`}</inlineCode>{`. Here's an example:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=typescript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2Findex.test.ts%0A%0Aimport%20%7B%20ParityPrice%20%7D%20from%20%22.%2Findex%22%3B%0Aimport%20*%20as%20fetchMock%20from%20%22isomorphic-fetch%22%3B%0A%0Aconst%20URL%20%3D%0A%20%20%20%20%22http%3A%2F%2Fapi.ipstack.com%2Fcheck%3Faccess_key%3D%3Capi%20key%3E%22%3B%0A%0Adescribe(%22ParityPrice%22%2C%20()%20%3D%3E%20%7B%0A%20%20%20%20beforeEach(()%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20fetchMock.reset()%3B%0A%20%20%20%20%7D)%3B%0A%20%20%20%20%0A%20%20%20%20test(%22returns%20Japan%20price%20for%20Japan%22%2C%20async%20()%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20fetchMock.mock(URL%2C%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20status%3A%20200%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20body%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20ip%3A%20%221.33.213.230%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20type%3A%20%22ipv4%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20continent_code%3A%20%22AS%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20continent_name%3A%20%22Asia%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20country_code%3A%20%22JP%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20country_name%3A%20%22Japan%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20region_code%3A%20%2213%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20region_name%3A%20%22Tokyo%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20city%3A%20%22Tokyo%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20zip%3A%20%22100-6801%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20latitude%3A%2035.688838958740234%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20longitude%3A%20139.7628631591797%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20location%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20geoname_id%3A%201850147%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20capital%3A%20%22Tokyo%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20languages%3A%20%5B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20code%3A%20%22ja%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20name%3A%20%22Japanese%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20native%3A%20%22%5Cu65e5%5Cu672c%5Cu8a9e%22%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%5D%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20country_flag%3A%20%22http%3A%2F%2Fassets.ipstack.com%2Fflags%2Fjp.svg%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20country_flag_emoji%3A%20%22%5Cud83c%5Cuddef%5Cud83c%5Cuddf5%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20country_flag_emoji_unicode%3A%20%22U%2B1F1EF%20U%2B1F1F5%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20calling_code%3A%20%2281%22%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20is_eu%3A%20false%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%7D)%3B%0A%0A%20%20%20%20%20%20%20%20const%20parity%20%3D%20new%20ParityPrice(%3Capi%20key%3E)%3B%0A%20%20%20%20%20%20%20%20await%20expect(parity.price(149)).resolves.toBe(96)%3B%0A%20%20%20%20%7D)%3B%0A%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "702px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "157.39910313901345%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'630\\'%20viewBox=\\'0%200%20400%20630\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M19%2029v572c0%202%2017%202%20181%202h181l1-2V29l-182-1-181%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d6ce3c8c9980c4d879459263ab612604/ca0a1/techletter.app-screenshot-1566489637051.webp 223w", "/static/d6ce3c8c9980c4d879459263ab612604/75680/techletter.app-screenshot-1566489637051.webp 445w", "/static/d6ce3c8c9980c4d879459263ab612604/de2ca/techletter.app-screenshot-1566489637051.webp 702w"],
                "sizes": "(max-width: 702px) 100vw, 702px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d6ce3c8c9980c4d879459263ab612604/e92b6/techletter.app-screenshot-1566489637051.png 223w", "/static/d6ce3c8c9980c4d879459263ab612604/e66bf/techletter.app-screenshot-1566489637051.png 445w", "/static/d6ce3c8c9980c4d879459263ab612604/d6331/techletter.app-screenshot-1566489637051.png 702w"],
                "sizes": "(max-width: 702px) 100vw, 702px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d6ce3c8c9980c4d879459263ab612604/d6331/techletter.app-screenshot-1566489637051.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We're in Jest now so we can use modern imports.`}</p>
    <p>{`Rest mocks before each test so there's no overlap, then mock an API request with a matcher and the response we want. The matcher in my case is a URL string, the exact URL my code is going to call, and the response is a JSON object.`}</p>
    <p>{`Response code `}<inlineCode parentName="p">{`200`}</inlineCode>{` for success and body for the data.`}</p>
    <p>{`Now when you call `}<inlineCode parentName="p">{`fetch(URL)`}</inlineCode>{` in the code, it won't make an API call, it's just gonna get this response object.`}</p>
    <p>{`Makes your tests fast, offline, and reliable. ✌️`}</p>
    <h2 {...{
      "id": "the-big-mac-purchasing-parity-code-were-testing"
    }}>{`The Big Mac purchasing parity code we're testing`}</h2>
    <p>{`TDD says to write your test first and your code second, but I actually wrote the code first. Here's the part we're testing above :)`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20src%2Findex.ts%0A%0Aconst%20fetch%20%3D%20require(%22isomorphic-fetch%22)%3B%0A%0Aexport%20class%20ParityPrice%20%7B%0A%20%20%20%20ipstack_key%3A%20string%3B%0A%0A%20%20%20%20constructor(ipstack_key%3A%20string%2C%20enable_ssl%3A%20boolean%20%3D%20false)%20%7B%0A%20%20%20%20%20%20%20%20this.ipstack_key%20%3D%20ipstack_key%3B%0A%20%20%20%20%7D%0A%0A%20%20%20%20private%20async%20ipstack(IP%3F%3A%20string)%20%7B%0A%20%20%20%20%20%20%20%20const%20param%20%3D%20IP%20%3F%20IP%20%3A%20%22check%22%3B%0A%0A%20%20%20%20%20%20%20%20const%20res%20%3D%20await%20fetch(%0A%20%20%20%20%20%20%20%20%20%20%20%20%60http%3A%2F%2Fapi.ipstack.com%2Fcheck%3Faccess_key%3D%24%7Bthis.ipstack_key%7D%60%0A%20%20%20%20%20%20%20%20)%3B%0A%20%20%20%20%20%20%20%20return%20res.json()%3B%0A%20%20%20%20%7D%0A%20%20%20%20%0A%20%20%20%20private%20_price(USAprice%3A%20number%2C%20location%3A%20any)%3A%20number%20%7B%0A%20%20%20%20%20%20%20%20const%20pricePerBurger%20%3D%20USAprice%20%2F%20BigMacIndex%5B%22United%20States%22%5D%3B%0A%0A%20%20%20%20%20%20%20%20let%20fairPrice%20%3D%20USAprice%3B%0A%0A%20%20%20%20%20%20%20%20if%20(location.country_name%20in%20BigMacIndex)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20fairPrice%20%3D%20Math.round(%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20pricePerBurger%20*%20BigMacIndex%5Blocation.country_name%5D%0A%20%20%20%20%20%20%20%20%20%20%20%20)%3B%0A%20%20%20%20%20%20%20%20%7D%20%2F%2F%20...%20a%20few%20other%20hacks%0A%0A%20%20%20%20%20%20%20%20return%20fairPrice%3B%0A%20%20%20%20%7D%0A%20%20%20%20%0A%20%20%20%20async%20price(USAprice%3A%20number%2C%20IP%3F%3A%20string)%3A%20Promise%3Cnumber%3E%20%7B%0A%20%20%20%20%20%20%20%20const%20location%20%3D%20await%20this.ipstack(IP)%3B%0A%20%20%20%20%20%20%20%20const%20fairPrice%20%3D%20this._price(USAprice%2C%20location)%3B%0A%0A%20%20%20%20%20%20%20%20return%20fairPrice%3B%0A%20%20%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "686px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "132.28699551569508%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'529\\'%20viewBox=\\'0%200%20400%20529\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M20%2029a21113%2021113%200%20001%20472h359l1-237V29l-181-1-180%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c57aa7fa37dfa8cd8730d8324172392f/ca0a1/techletter.app-screenshot-1566489636939.webp 223w", "/static/c57aa7fa37dfa8cd8730d8324172392f/75680/techletter.app-screenshot-1566489636939.webp 445w", "/static/c57aa7fa37dfa8cd8730d8324172392f/7dbce/techletter.app-screenshot-1566489636939.webp 686w"],
                "sizes": "(max-width: 686px) 100vw, 686px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c57aa7fa37dfa8cd8730d8324172392f/e92b6/techletter.app-screenshot-1566489636939.png 223w", "/static/c57aa7fa37dfa8cd8730d8324172392f/e66bf/techletter.app-screenshot-1566489636939.png 445w", "/static/c57aa7fa37dfa8cd8730d8324172392f/f6386/techletter.app-screenshot-1566489636939.png 686w"],
                "sizes": "(max-width: 686px) 100vw, 686px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c57aa7fa37dfa8cd8730d8324172392f/f6386/techletter.app-screenshot-1566489636939.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You instantiate `}<inlineCode parentName="p">{`ParityPrice`}</inlineCode>{` with your `}<a parentName="p" {...{
        "href": "https://ipstack.com/"
      }}>{`Ipstack`}</a>{` API key (you can get one for free) and call `}<inlineCode parentName="p">{`.price()`}</inlineCode>{` with the price you're trying to parity match.`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/Swizec/bigmac-index-price-calculator"
      }}>{`bigmac-index-price-calculator`}</a>{` then calls Ipstack to geolocate your visitor based on IP, looks up their country in the BigMacIndex and returns the adjusted price.`}</p>
    <p>{`The full version has some continent-based conversions when a country isn't found and a bit of caching so you can call multiple times without making too many requests. It works pretty well.`}</p>
    <p><strong parentName="p">{`RIDICULOUS WARNING`}</strong>{` 👉 notice the `}<inlineCode parentName="p">{`const fetch = require()`}</inlineCode>{` part up top? That's because while modern imports work for Jest files and they definitely work when packaging your library, `}<em parentName="p">{`I couldn't get them to work when testing your library`}</em>{`. I tried everything. Nothing worked.`}</p>
    <h2 {...{
      "id": "purchasing-power-parity-on-reactfordatavizcom"
    }}>{`Purchasing power parity on reactfordataviz.com`}</h2>
    <p>{`You can see `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Big_Mac_Index"
      }}>{`Big Mac Index`}</a>{` purchasing power parity in action on `}<a parentName="p" {...{
        "href": "https://reactfordataviz-staging.swizec.now.sh/"
      }}>{`https://reactfordataviz-staging.swizec.now.sh/`}</a>{`. Scroll down and you'll see a custom price for your location.`}</p>
    <p>{`Don't click the button yet though. I haven't wired up the adjusted prices with Gumroad yet.`}</p>
    <p>{`A lot of people have been asking for this and I think it's a great idea. Value based pricing all the way. If learning React Dataviz gets you a $150,000/year job in USA that's very different value than a $50,000/year job somewhere else.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      